const INITIAL_STATE = {
  code: ' ',
};

export default function branchCode(state = INITIAL_STATE, action) {
  switch (action.type) {
    case "SET_BRANCH_CODE":
      return {
        ...state,
        code: action.code
      };
    default:
      return state;
  }
}
